import { GlobalErrorBoundary } from "../components/GlobalErrorBoundary";

export default function UpsPage() {
  return <GlobalErrorBoundary />;
}
